import { Node } from '@xyflow/react';

export function calculateForLoopNestingDepth(nodeId: string, nodes: Node[]): number {
  const node = nodes.find(n => n.id === nodeId);
  if (!node || node.type !== 'for_loop') {
    return 0;
  }

  let depth = 0;
  let currentNode: Node | undefined = node;

  while (currentNode?.parentId) {
    const parentNode = nodes.find(n => n.id === currentNode?.parentId);
    if (parentNode && parentNode.type === 'for_loop') {
      depth++;
    }
    currentNode = parentNode;
  }

  return depth;
}

export function calculatePotentialNestingDepth(containerNode: Node, nodes: Node[]): number {
  if (!containerNode || containerNode.type !== 'for_loop') {
    return 0;
  }

  return calculateForLoopNestingDepth(containerNode.id, nodes) + 1;
}

export function wouldExceedNestingLimit(
  containerNode: Node | null,
  nodes: Node[],
  maxDepth: number = 4
): boolean {
  if (!containerNode) {
    return false;
  }

  const potentialDepth = calculatePotentialNestingDepth(containerNode, nodes);
  return potentialDepth >= maxDepth;
}
